<script lang="ts" setup>

	const emit = defineEmits(['toggle-favorites']);

	const toggleFavoriteView = () => emit('toggle-favorites');

</script>

<template>
	<div class="favorites-back-button">
		<a href="#" @click.stop.prevent="toggleFavoriteView">
			<svg class="icon-chevron-left" height="12" width="9">
				<use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#chevron-left"></use>
			</svg>
			{{ $t('site.products.overview.favorites.back.button.text') }}
		</a>
	</div>
</template>

<style lang="scss" scoped>
	.favorites-back-button {
		margin-top: 70px;
		padding-right: 20px;
		float: left;
		text-align: right;
		font-size: .875em;
		line-height: 1.14286em;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: .14286em;
		width: 25%;
		max-width: 300px;

		a {
			padding: 7px 10px;
			text-decoration: none;
		}
	}
</style>
